export default {
    fullname: "Nanthawat Bunsriphum",
    nickname: "@tut-ta.na",
    birthyear: 1996,
    tel: "088-791-9550",
    line: "tu-ta.na",
    mail: "sur.nanthawat@gmail.com",
    county: "Thailand",
    address: "Bangkok",
    freelance: "Available",
    about: "I’m working as a style planner and web developer. I’m graduated in  software development and develop websites for many firms and government  agencies for over the past 3 years, I have gained experiences via types  of websites.",
    images: "/images/profile/profile-t.png",
    no_images: "/images/profile/profile-t.png",
    social: {
        facebook: "https://facebook.com/nantawat.bunsriphum/",
        linkedin: "",
        github: "https://github.com/somoene-n",
    },
    work:[
        "Software Engineer",
        "Web Developer",
        "FullStack Developer",
        "Research and Development",
    ],
    certificates: [
        {
            title: "Certificate ITPE<br>IP",
            category: "สวทช.",
            images: [
                "/images/profile/itpe-ta.jpg",
                "/images/profile/itpe-ta.jpg",
            ],
        },
        {
            title: "Certificate IC3",
            category: "สถาบันคุณวุฒิวิชาชีพ",
            images: [
                "/images/profile/ic3-ta.png",
            ],
        },
    ],
    awards: {
        fullname: "Nanthawat Bunsriphum",
        images: "/images/profile/profile-t.png",
        work: "FullStack Developer",
        desc: "All awards received since college.",
        list: [
            {
                title: "04 September 2016",
                desc: "ACM ICPC 2016 รองชนะเลิศอันดับ 1 ระดับภูมิภาคเหนือ",
            },
            {
                title: "17 - 18 October 2010",
                desc: "ACM ICPC 2016 ระดับประเทศ Thailand National On-site",
            },
            {
                title: "01 April 2018",
                desc: "Startup Thailand 2018",
            },
            {
                title: "30 November 2016",
                desc: "UP Disrupt 2016",
            },
        ],
    },
    resume: {
        experiences: [
            {
                isActive: true,
                year: "2019 - Present",
                subject: "CXO & Developer",
                title: "Decodethailand Team.",
                desc: "Working as a freelancer about web development and mobile application.",
            },
            {
                isActive: false,
                year: "2019 - Present",
                subject: "Web, mobile application <br> developer / Research and <br> development.",
                title: "Wewebplus Co,. Ltd.",
                desc: "Web developer.",
            }
        ],
        educations: [
            {
                isActive: false,
                year: "2015 - 2019",
                subject: "University Of Phayao",
                title: "Phayao, Thailand",
                desc: "Software Engineering Major.",
            },
            {
                isActive: false,
                year: "2009 - 2015",
                subject: "Nachaliang Pittayakom School",
                title: "Phetchabun, Thailand",
                desc: "Science - Mathematics.",
            },
        ],
    },
    skills: [
        {
            title: "The Ability to Communicate",
            scale: "70%",
        },
        {
            title: "Always seeking new knowledge",
            scale: "80%",
        },
        {
            title: "Reasoning and Problem Solving",
            scale: "75%",
        },
        {
            title: "Enthusiasm for work",
            scale: "75%",
        },
    ],
    languages: [
        {
            title: "Thai",
            scale: "98%", //10-100
        },
        {
            title: "English",
            scale: "30%",
        },
    ],
    knowledges: [
        "Adaptability",
        "Strong Research Skills",
        "The Ability to Get Focused",
        "Communicate",
        "The Ability to Meet Deadlines",
        "Organizational Skills",
        "Always seeking new knowledge",
    ],
}